import { render, staticRenderFns } from "./SimplePricing.vue?vue&type=template&id=0d9f4d34&scoped=true"
import script from "./SimplePricing.vue?vue&type=script&lang=js"
export * from "./SimplePricing.vue?vue&type=script&lang=js"
import style0 from "./SimplePricing.vue?vue&type=style&index=0&id=0d9f4d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f4d34",
  null
  
)

export default component.exports